import { METHOD } from 'services/method'

export const API_ABOUT_US = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/about-us',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/about-us',
        method: METHOD.PUT,
    },
    URL_ABOUT_US_IMAGE: {
        api: '/v1/dashboard-admin/main-page/about-us/storage-url/attachment',
        method: METHOD.POST,
    },
}
